var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPlansWhiteIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18.292,
    viewBox: "0 0 18 18.292",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Plans_default_16px",
    transform: "translate(-369 -160.708)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_160566",
    "data-name": "Group 160566",
    transform: "translate(369 161)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Plans_Outline_24px"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1094",
    "data-name": "Rectangle 1094",
    width: 18,
    height: 18,
    fill: "#787f88",
    opacity: 0
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_122",
    "data-name": "Ellipse 122",
    cx: 0.496,
    cy: 0.496,
    r: 0.496,
    transform: "translate(15.244 12.666)",
    fill: "#787f88"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1039",
    "data-name": "Path 1039",
    d: "M17.408,16.564a1.712,1.712,0,0,1-1.7,1.719H4.744a1.712,1.712,0,0,1-1.7-1.719V3.709a1.712,1.712,0,0,1,1.7-1.719H15.7a1.712,1.712,0,0,1,1.7,1.719v9.067",
    transform: "translate(-1.668 -1.532)",
    fill: "none",
    stroke: "#787f88",
    strokeLinecap: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_3222",
    "data-name": "Group 3222",
    transform: "translate(6.606 3.468)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3221",
    "data-name": "Group 3221",
    transform: "translate(1.898)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_21",
    "data-name": "Line 21",
    y2: 0.949,
    fill: "none",
    stroke: "#787f88",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_22",
    "data-name": "Line 22",
    y2: 1.019,
    transform: "translate(0.017 6.662)",
    fill: "none",
    stroke: "#787f88",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_1040",
    "data-name": "Path 1040",
    d: "M13.116,7.79h-2.36a1.1,1.1,0,1,0,0,2.195h1.568a1.1,1.1,0,1,1,0,2.195H9.65",
    transform: "translate(-9.65 -6.127)",
    fill: "none",
    stroke: "#787f88",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1095",
    "data-name": "Rectangle 1095",
    width: 1.306,
    height: 1.306,
    rx: 0.36,
    transform: "translate(3.652 13.116)",
    fill: "#787f88"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1096",
    "data-name": "Rectangle 1096",
    width: 8.056,
    height: 1.306,
    rx: 0.653,
    transform: "translate(5.653 13.116)",
    fill: "#787f88"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlansWhiteIcon);
export default __webpack_public_path__ + "static/media/plans-white-icon.17f7dc47881ffd1485c037c0dc132c93.svg";
export { ForwardRef as ReactComponent };